import { Link } from 'react-router-dom';
import { ApiHelper } from '../apiHelper/ApiHelper';
import { formatPrice } from './ProductCatalog';
import './styles/BankTransferInstructions.scss';

export type BankTransferInfo = {
    amount: number;
    variableSymbol?: string | null;
    iban?: string | null;
    accountDisplay?: string | null;
    qrCode?: string | null;
    installmentId?: string | null;
    invoiceId?: string | null;
};

type Props = {
    info: BankTransferInfo;
    canDownload?: boolean;
    // When the caller can show the card payment form in place (e.g. Checkout), pass a
    // handler here instead of linking away to the standalone /platba/:id page.
    onPayByCard?: () => void;
    payingByCard?: boolean;
};

// How to pay a pending order by bank transfer / QR. Reused by the checkout confirmation and
// the in-course "waiting for payment" screen. `canDownload` gates the (auth-only) invoice
// download so a not-yet-logged-in guest doesn't see a button that would 401.
export default function BankTransferInstructions({ info, canDownload = false, onPayByCard, payingByCard = false }: Props) {
    const api = new ApiHelper();

    async function download() {
        if (!info.invoiceId) return;
        try {
            await api.downloadInvoice(info.invoiceId, "faktura.pdf");
        } catch (x: any) {
            api.processErrors(x);
        }
    }

    return (
        <div className="bankTransfer">
            <div className="btRows">
                <div className="btRow"><span>Částka</span><b>{formatPrice(info.amount)}</b></div>
                {info.accountDisplay && <div className="btRow"><span>Číslo účtu</span><b>{info.accountDisplay}</b></div>}
                {info.iban && <div className="btRow"><span>IBAN</span><b>{info.iban}</b></div>}
                {info.variableSymbol && <div className="btRow"><span>Variabilní symbol</span><b>{info.variableSymbol}</b></div>}
            </div>

            {info.qrCode &&
                <div className="btQr">
                    <span>Nebo naskenuj QR platbu v bankovní aplikaci:</span>
                    <img src={info.qrCode} alt="QR platba" />
                </div>
            }

            <div className="btActions">
                {info.installmentId && onPayByCard ?
                    <button type="button" className="btBtn" disabled={payingByCard} onClick={onPayByCard}>
                        {payingByCard ? "Načítání…" : "Zaplatit kartou místo toho"}
                    </button>
                    : info.installmentId &&
                    <Link to={"/platba/" + info.installmentId} className="btBtn">Zaplatit kartou místo toho</Link>
                }
                {canDownload && info.invoiceId &&
                    <button type="button" className="btBtn ghost" onClick={download}>Stáhnout fakturu</button>
                }
            </div>
        </div>
    );
}
